module.exports = __webpack_public_path__ + "media/honey-icons/icon-security-home-ef416a01.svg";